<script setup>
import { computed, inject } from 'vue'
import {
  DropdownMenuContent,
  DropdownMenuPortal,
  useForwardPropsEmits,
} from 'radix-vue'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  forceMount: { type: Boolean, required: false },
  loop: { type: Boolean, required: false },
  sideOffset: { type: Number, required: false, default: 2 },
  align: { type: null, required: false, default: 'start' },
  alignOffset: { type: Number, required: false },
  avoidCollisions: { type: Boolean, required: false },
  collisionBoundary: { type: null, required: false },
  collisionPadding: { type: [Number, Object], required: false },
  arrowPadding: { type: Number, required: false },
  sticky: { type: String, required: false },
  hideWhenDetached: { type: Boolean, required: false },
  updatePositionStrategy: { type: String, required: false },
  prioritizePosition: { type: Boolean, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false, default: 'ul' },
  class: { type: null, required: false },
})

defineOptions({
  inheritAttrs: false,
})

const emits = defineEmits([
  'escapeKeyDown',
  'pointerDownOutside',
  'focusOutside',
  'interactOutside',
  'closeAutoFocus',
])

const delegatedProps = computed(() => {
  const { class: _, ...delegated } = props

  return delegated
})

const context = inject('dropdownMenu')

const direction = computed(() => {
  if (context?.direction) return context.direction
  return 'bottom'
})

const forwarded = useForwardPropsEmits(delegatedProps, emits)
</script>

<template>
  <DropdownMenuPortal>
    <DropdownMenuContent
      v-bind="{ ...forwarded, ...$attrs }"
      :side="direction"
      :class="['dropdown-menu gu-dropdown-menu animated show position-relative', props.class]"
    >
      <slot />
    </DropdownMenuContent>
  </DropdownMenuPortal>
</template>

<style lang="scss">
.dropdown-menu.gu-dropdown-menu {
  z-index: 1060; // greather than modal backgdrop (1050)

  &[data-state='open'] {
    animation: fade-in 0.15s ease-out;
  }

  &[data-state='closed'] {
    animation: fade-out 0.15s ease-out;
  }
}
</style>
